import * as Yup from 'yup'

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/


export const customerFormSchema = Yup.object({
    name: Yup.string().min(3, 'Length of Name must be between 3 and 30 letters').max(30, 'Length of Name must be between 3 and 30 letters').required('Required'),
    email: Yup.string().email('Email is Invalid').required('Required'),
    password: Yup.string().required('Required'),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], 'Password Does Not Match').required('Required'),
    contact: Yup.string().required('Required'),
    country: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    street: Yup.string().required('Required'),
    zip: Yup.string().required('Required')
})

export const authorFormSchema = Yup.object({
    name: Yup.string().min(3, 'Length of Name must be between 3 and 30 letters').max(30, 'Length of Name must be between 3 and 30 letters').required('Required'),
    email: Yup.string().email('Email is Invalid').required('Required'),
    password: Yup.string().required('Required'),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], 'Password Does Not Match').required('Required'),
    contact: Yup.string().required('Required'),
    biography: Yup.string().required('Required'),
    booksInfo: Yup.string().required('Required')
})